import React from 'react';
import './SelectedWellFilters.scss';
import { ReactComponent as CloseIcon } from '../../images/close-x-icon.svg';
import { setHasSelectedFilters } from './WellFilterSlice';
import { useAppDispatch } from '../../hooks/storeHooks';

type SectionFilter = { section: string; value: string; id?: number | string };
interface SelectedWellFiltersProps {
  filters: SectionFilter[];
  onRemoveFilter: (filter: SectionFilter | 'ALL') => void;
  recommendationsPage?: boolean;
}

const SelectedWellFilters: React.FC<SelectedWellFiltersProps> = ({ filters, onRemoveFilter, recommendationsPage }) => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(setHasSelectedFilters(filters.length > 0));
  }, [filters, dispatch]);

  return (
    <>
      {filters.length > 0 ? (
        <div className='summary-header-filters-slot'>
          <div
            className={`header-selected-well-filters-container ${recommendationsPage ? 'recommendations-page-header-selected-well-filters' : ''}`}
          >
            <div className='selected-well-filters-container-row'>
              <div className='selected-well-filters-container'>
                {filters.map((filter, idx) => (
                  <div key={`${filter.section}:${filter.value}:${String(idx)}`} className='selected-well-filter-box'>
                    <span className='selected-well-filter-label'>{filter.value}</span>
                    <span
                      className='selected-well-filter-remove'
                      onClick={() => onRemoveFilter(filter)}
                      title='Remove filter'
                    >
                      <CloseIcon style={{ color: '#60bfda' }} />
                    </span>
                  </div>
                ))}
              </div>
              {filters.length > 0 && (
                <button
                  type='button'
                  className={`selected-well-filter-clear-all-btn ${recommendationsPage ? 'recommendations-selected-well-filter-clear-all-btn' : ''}`}
                  onClick={() => onRemoveFilter('ALL')}
                >
                  Clear all
                </button>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default SelectedWellFilters;
